export default __webpack_public_path__ + "static/media/1509.97464d67.png";